/*!
 * Copyright 2022 Thorne Health Lab. All rights reserved.
 */
import { PublicClientApplication } from '@azure/msal-browser';

const msalConfig = {
  auth: {
    clientId: process.env.LAB100_APP_MSAL_CLIENT_ID,
    authority: `https://${process.env.LAB100_APP_MSAL_AUTHORITY}.b2clogin.com/${process.env.LAB100_APP_MSAL_AUTHORITY}.onmicrosoft.com/B2C_1_signIn`,
    knownAuthorities: [
      `${process.env.LAB100_APP_MSAL_AUTHORITY}.b2clogin.com`
    ],
    redirectUri: process.env.LAB100_APP_MSAL_REDIRECT_URI,
    postLogoutRedirectUri: process.env.LAB100_APP_MSAL_REDIRECT_URI,
    navigateToLoginRequestUrl: false
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false
  }
};

const b2cScopes = [
  'openid',
  'offline_access',
  `https://${process.env.LAB100_APP_MSAL_AUTHORITY}.onmicrosoft.com/th-api-${process.env.LAB100_APP_ENVIRONMENT}/tasks.read`
]

const loginRequest = {
  scopes: b2cScopes
};

const msalInstance = new PublicClientApplication(msalConfig);

const storeToken = accessToken => {
  localStorage.setItem('token', accessToken);
};


const getToken = ()=>{
  return localStorage.getItem('token')
}

const setLoginClick = status => {
  sessionStorage.setItem('login', status)
}

const getLoginClick = ()=>{
  return sessionStorage.getItem('login') || true
}

const checkInterationStatus = ()=>{
  return sessionStorage.getItem('msal.account.keys')?.length || 0
}

export { loginRequest, msalInstance, storeToken, b2cScopes, getToken, setLoginClick, getLoginClick, checkInterationStatus }


// e9b00923-454c-4c3f-9e6f-6cfd44fb9cc9
